export const viewItemParagraphStyle = { maxWidth: '40em' };
